<template>
  <div class="enterpriseAndCommonality">
    <div class="AddSupplierA">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="contactsForm"
      >
        <div class="AddSupplierATitle">企业信息</div>
        <div class="AddSupplierAContent">
          <!-- <esoterica @setIsShowHelpExplain="setIsShowHelpExplain"></esoterica> -->

          <el-row>
            <el-col :span="12">
              <!--公司名称-->
              <el-form-item
                class="noMarginBottom"
                label="公司名称："
                prop="companyName"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.companyName"
                  maxlength="60"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
            </el-col>
            <el-col :span="12">
              <!--注册地址-->
              <el-form-item
                class="noMarginBottom"
                label="注册地址："
                prop="registeAddress"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.registeAddress"
                  maxlength="60"
                  placeholder="请输入注册地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--办公地址-->
              <el-form-item
                class="noMarginBottom"
                label="办公地址："
                prop="workAddress"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.workAddress"
                  maxlength="60"
                  placeholder="请输入办公地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--办公电话-->
              <el-form-item
                label="办公电话："
                class="noMarginBottom"
                prop="workPhone"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.workPhone"
                  maxlength="20"
                  placeholder="请输入办公电话"
                  @blur="shopNameBlur"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--法人姓名-->
              <el-form-item
                class="noMarginBottom"
                label="法人姓名："
                prop="legalPerson"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.legalPerson"
                  maxlength="12"
                  placeholder="请输入法人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item class="noMarginBottom" label="分类：">
                <!-- <el-select
                  v-model="ruleForm.topType"
                  placeholder="请选择一级分类"
                  default-first-option
                  :disabled="type=='aType'"
                >
                  <el-option label="甲方" value="aType"></el-option>
                  <el-option label="乙方" value="bType"></el-option>
                </el-select>
              </el-form-item>
                <el-form-item class="noMarginBottom" label=''>-->
                <el-select
                  v-model="ruleForm.typeRelList[0].topId"
                  filterable
                  default-first-option
                  placeholder="请选择一级分类"
                  @change="firstSupplierTypeChange"
                >
                  <el-option
                    :label="supplier.typeValue"
                    :value="supplier.id"
                    v-for="supplier in firstSupplierTypeList"
                    :key="supplier.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item class="noMarginBottom" label label-width="20px">
                <el-select
                  v-model="ruleForm.typeRelList[0].secondId"
                  filterable
                  default-first-option
                  placeholder="请选择二级分类"
                  clearable
                  @change="secondSupplierTypeChange"
                >
                  <el-option
                    :label="supplier.typeValue"
                    :value="supplier.id"
                    v-for="supplier in secondSupplierTypeList"
                    :key="supplier.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item class="noMarginBottom" label label-width="20px">
                <el-select
                  v-model="ruleForm.typeRelList[0].thirdId"
                  filterable
                  default-first-option
                  placeholder="请选择三级分类"
                  clearable
                >
                  <el-option
                    :label="supplier.typeValue"
                    :value="supplier.id"
                    v-for="supplier in thirdSupplierTypeList"
                    :key="supplier.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">对公户信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <!--公司名称-->
              <el-form-item
                class="noMarginBottom"
                label="公司名称："
                prop="publicCompanyName"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicCompanyName"
                  maxlength="60"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
            </el-col>
            <el-col :span="12">
              <!--开户行-->
              <el-form-item
                class="noMarginBottom"
                label="开户行："
                prop="publicBank"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBank"
                  maxlength="60"
                  placeholder="请输入开户行名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--开户行地址-->
              <el-form-item
                class="noMarginBottom"
                label="开户行地址："
                prop="publicBankAddress"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankAddress"
                  maxlength="60"
                  placeholder="请输入开户行地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--开户行账号-->
              <el-form-item
                class="noMarginBottom"
                label="账号："
                prop="publicBankAccount"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankAccount"
                  maxlength="24"
                  placeholder="请输入对公户账号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--税号-->
              <el-form-item
                class="noMarginBottom"
                label="税号："
                prop="publicTaxAccount"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicTaxAccount"
                  maxlength="24"
                  placeholder="请输入对公户税号"
                  @input="publicTaxAccountInput"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--开户行行号-->
              <el-form-item
                class="noMarginBottom"
                label="开户行行号："
                prop="publicBankNumber"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankNumber"
                  maxlength="24"
                  placeholder="请输入开户行行号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--对公电话-->
              <el-form-item
                class="noMarginBottom"
                label="对公户电话："
                prop="publicPhone"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicPhone"
                  maxlength="12"
                  placeholder="请输入对公户电话号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">联系人信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <!--联系人姓名-->
              <el-form-item
                class="noMarginBottom"
                label="联系人姓名："
                prop="contactName"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactName"
                  maxlength="30"
                  placeholder="请输入联系人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--联系人电话-->
              <el-form-item
                class="noMarginBottom"
                label="联系人电话："
                prop="contactPhone"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactPhone"
                  maxlength="12"
                  placeholder="请输入联系人电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--电子邮箱-->
              <el-form-item
                class="noMarginBottom"
                label="电子邮箱："
                prop="contactEmail"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactEmail"
                  maxlength="30"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--对公电话-->
              <el-form-item
                class="noMarginBottom"
                label="传真电话："
                prop="contactFax"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactFax"
                  maxlength="12"
                  placeholder="请输入传真电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">开票信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="发票抬头：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicCompanyName"
                  maxlength="60"
                  placeholder="请输入发票抬头"
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="纳税人识别号：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicTaxAccount"
                  maxlength="60"
                  placeholder="请输入纳税人识别号"
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="单位地址：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.registeAddress"
                  maxlength="60"
                  placeholder="请输入单位地址"
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="电话号码：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.workPhone"
                  maxlength="12"
                  placeholder="请输入电话号码"
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="开户银行：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBank"
                  maxlength="60"
                  placeholder="请输入开户银行"
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="银行账号：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankAccount"
                  maxlength="24"
                  placeholder="请输入银行账号"
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">材料</div>
        <div class="AddSupplierAContent">
          <!--经营许可证照片-->
          <!-- <div class="businessBox">
            <div class="businessTitle">
              <span class="startTxt">*</span>
              <span>经营许可证照片</span>
              <el-popover placement="top-start" width="400" trigger="hover">
                <div slot="reference">
                  <img
                    src="@/assets/images/supplierImg/info-circle-oanticon.png"
                    alt
                  />
                </div>
                <div>
                  <div>经营许可证照片</div>
                  <img
                    style="width: 400px"
                    src="@/assets/images/supplierImg/2.png"
                    alt
                  />
                </div>
              </el-popover>
              <span>：</span>
            </div>
            <div>
              <el-row>
                <el-col :span="12">
                  <el-upload
                    class="upload-demo"
                    drag
                    :show-file-list="isShowFileList"
                    :file-list="triangleFileList"
                    :on-success="triangleUploadSuccess"
                    :action="uploadPicUrl"
                    :before-upload="beforeMaxUpload"
                    :headers="headers"
                  >
                    <div v-if="triangleFileList.length == 0">
                      <img
                        class="fileImgIcon"
                        src="@/assets/images/supplierImg/catalog1_active.png"
                        alt
                      />
                      <div class="dragTxt">经营许可证照片1</div>
                      <div class="imgSizeTxt">
                        图片尺寸5M以内 支持.jpg .jpeg .png 格式 最多上传1张
                      </div>
                    </div>
                    <div
                      class="uploadImgBox"
                      v-if="triangleFileList.length != 0"
                    >
                      <img :src="triangleFileList[0].url" alt height="194" />
                      <div class="coloseAndPreviewBtnList">
                        <div class="closeBtn" @click.stop="closeBtnClick(1)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click.stop="previewBtnClick(triangleFileList[0])"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </el-upload>
                </el-col>
                <el-col :span="11" style="margin-left: 10px">
                  <el-upload
                    class="upload-demo"
                    drag
                    :show-file-list="isShowFileList"
                    :file-list="triangleFileList1"
                    :on-success="triangleUploadSuccess1"
                    :action="uploadPicUrl"
                    :before-upload="beforeMaxUpload"
                    :headers="headers"
                  >
                    <div v-if="triangleFileList1.length == 0">
                      <img
                        class="fileImgIcon"
                        src="@/assets/images/supplierImg/catalog1_active.png"
                        alt
                      />
                      <div class="dragTxt">经营许可证照片2</div>
                      <div class="imgSizeTxt">
                        图片尺寸5M以内 支持.jpg .jpeg .png 格式 最多上传1张
                      </div>
                    </div>
                    <div
                      class="uploadImgBox"
                      v-if="triangleFileList1.length != 0"
                    >
                      <img :src="triangleFileList1[0].url" alt height="194" />
                      <div class="coloseAndPreviewBtnList">
                        <div class="closeBtn" @click.stop="closeBtnClick(4)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click.stop="previewBtnClick(triangleFileList1[0])"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </el-upload>
                </el-col>
              </el-row>
            </div>
          </div>-->
          <!--法人身份证反正面-->
          <!-- <div class="businessBox">
            <div class="businessTitle">
              <span class="startTxt">*</span>
              <span>法人身份证反正面</span>
              <el-popover placement="top-start" width="400" trigger="hover">
                <div slot="reference">
                  <img
                    src="@/assets/images/supplierImg/info-circle-oanticon.png"
                    alt
                  />
                </div>
                <div>
                  <div>
                    公司法人身份证正反面，扫描原件或复印件加盖红章及法人签字。
                  </div>
                  <img
                    style="width: 400px"
                    src="@/assets/images/supplierImg/IdCard.png"
                    alt
                  />
                </div>
              </el-popover>
              <span>：</span>
            </div>
            <div>
              <el-row>
                <el-col :span="12">
                  <el-upload
                    class="upload-demo"
                    drag
                    :show-file-list="isShowFileList"
                    :file-list="identitycardFrontFileList"
                    :on-success="identitycardFrontUploadSuccess"
                    :action="uploadPicUrl"
                    :before-upload="beforeUpload"
                    :headers="headers"
                  >
                    <div v-if="identitycardFrontFileList.length == 0">
                      <img
                        class="fileImgIcon"
                        src="@/assets/images/supplierImg/catalog1_active.png"
                        alt
                      />
                      <div class="dragTxt">身份证正面照片</div>
                      <div class="imgSizeTxt">
                        图片尺寸1M以内 支持.jpg .jpeg .png 格式 最多上传1张
                      </div>
                    </div>
                    <div
                      class="uploadImgBox"
                      v-if="identitycardFrontFileList.length != 0"
                    >
                      <img
                        :src="identitycardFrontFileList[0].url"
                        alt
                        height="194"
                      />
                      <div class="coloseAndPreviewBtnList">
                        <div class="closeBtn" @click.stop="closeBtnClick(2)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click.stop="
                            previewBtnClick(identitycardFrontFileList[0])
                          "
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </el-upload>
                </el-col>
                <el-col :span="11" style="margin-left: 10px">
                  <el-upload
                    class="upload-demo secondUpload"
                    drag
                    :data="uploadData"
                    :show-file-list="isShowFileList"
                    :file-list="identitycardReverseFileList"
                    :on-success="identitycardReverseUploadSuccess"
                    :action="uploadPicUrl"
                    :before-upload="beforeUpload"
                    :headers="headers"
                  >
                    <div v-if="identitycardReverseFileList.length == 0">
                      <img
                        class="fileImgIcon"
                        src="@/assets/images/supplierImg/catalog1_active.png"
                        alt
                      />
                      <div class="dragTxt">身份证反面照片</div>
                      <div class="imgSizeTxt">
                        图片尺寸1M以内 支持.jpg .jpeg .png 格式 最多上传1张
                      </div>
                    </div>
                    <div
                      class="uploadImgBox"
                      v-if="identitycardReverseFileList.length != 0"
                    >
                      <img
                        :src="identitycardReverseFileList[0].url"
                        alt
                        height="194"
                      />
                      <div class="coloseAndPreviewBtnList">
                        <div class="closeBtn" @click.stop="closeBtnClick(3)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click.stop="
                            previewBtnClick(identitycardReverseFileList[0])
                          "
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </el-upload>
                </el-col>
              </el-row>
            </div>
          </div>-->
          <!--材料1-->
          <div class="businessBox">
            <div class="certificateTitle">
              <span>材料1</span>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
              ></el-popover>
              <span>：</span>
            </div>
            <div class="addImgUploadBox">
              <el-upload
                class="addImgUpload"
                :action="uploadPicUrl"
                :show-file-list="isShowFileList"
                :data="uploadData"
                :limit="addImgUploadLimit2"
                :on-success="restsUploadSuccess1"
                list-type="text"
                accept="image/*"
                :on-exceed="exceedFilesNum2"
                :before-upload="beforeUpload"
                :file-list="restsFileImgList1"
                :headers="headers"
              >
                <div class="addImgBox">
                  <div class="addImgIcon">
                    <img src="@/assets/images/supplierImg/addImgIcon.png" alt />
                  </div>
                </div>
                <div class="imgIconTxt">
                  图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                  <span v-show="restsFileList1.length != 0"
                    >（{{ restsFileList1.length }}/2）</span
                  >。
                </div>
              </el-upload>
              <div class="UploadImgList" v-if="restsFileList1.length != 0">
                <div
                  class="UploadImgItem"
                  v-for="(
                    cosmeticSanitationFileItem, cosmeticSanitationFileIndex
                  ) in restsFileList1"
                  :key="
                    'cosmeticSanitationFileItem' + cosmeticSanitationFileIndex
                  "
                >
                  <div class="UploadImgLeft">
                    <div class="UploadItemImg">
                      <img :src="cosmeticSanitationFileItem.url" alt />
                    </div>
                    <div class="UploadItemInfo">
                      <div class="UploadItemName">
                        图片{{ cosmeticSanitationFileIndex + 1 }}
                      </div>
                    </div>
                  </div>
                  <div class="UploadImgBtnList">
                    <div
                      @click="handleRestsRemove1(cosmeticSanitationFileItem)"
                    >
                      删除
                    </div>
                    <div
                      class="previewBtn"
                      @click="
                        handlePictureCardPreview(cosmeticSanitationFileItem)
                      "
                    >
                      预览
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--材料2-->
          <div class="businessBox">
            <div class="certificateTitle">
              <span>材料2</span>
              <el-popover placement="top-start" width="400" trigger="hover">
                <div>
                  <div>
                    需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                  </div>
                </div>
              </el-popover>
              <span>：</span>
            </div>
            <div class="addImgUploadBox">
              <el-upload
                class="addImgUpload"
                :action="uploadPicUrl"
                :show-file-list="isShowFileList"
                :data="uploadData"
                :limit="addImgUploadLimit2"
                :on-success="restsUploadSuccess2"
                list-type="text"
                accept="image/*"
                :on-exceed="exceedFilesNum2"
                :before-upload="beforeUpload"
                :file-list="restsFileImgList2"
                :headers="headers"
              >
                <div class="addImgBox">
                  <div class="addImgIcon">
                    <img src="@/assets/images/supplierImg/addImgIcon.png" alt />
                  </div>
                </div>
                <div class="imgIconTxt">
                  图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                  <span v-show="restsFileList2.length != 0"
                    >（{{ restsFileList2.length }}/2）</span
                  >。
                </div>
              </el-upload>
              <div class="UploadImgList" v-if="restsFileList2.length != 0">
                <div
                  class="UploadImgItem"
                  v-for="(restsFileItem, restsFileIndex) in restsFileList2"
                  :key="'restsFileItem' + restsFileIndex"
                >
                  <div class="UploadImgLeft">
                    <div class="UploadItemImg">
                      <img :src="restsFileItem.url" alt />
                    </div>
                    <div class="UploadItemInfo">
                      <div class="UploadItemName">
                        图片{{ restsFileIndex + 1 }}
                      </div>
                    </div>
                  </div>
                  <div class="UploadImgBtnList">
                    <div @click="handleRestsRemove2(restsFileItem)">删除</div>
                    <div
                      class="previewBtn"
                      @click="handlePictureCardPreview(restsFileItem)"
                    >
                      预览
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--材料3-->
          <div class="businessBox">
            <div class="certificateTitle">
              <span>材料3</span>
              <el-popover placement="top-start" width="400" trigger="hover">
                <div>
                  <div>
                    需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                  </div>
                </div>
              </el-popover>
              <span>：</span>
            </div>
            <div class="addImgUploadBox">
              <el-upload
                class="addImgUpload"
                :action="uploadPicUrl"
                :show-file-list="isShowFileList"
                :data="uploadData"
                :limit="addImgUploadLimit2"
                :on-success="restsUploadSuccess3"
                list-type="text"
                accept="image/*"
                :on-exceed="exceedFilesNum2"
                :before-upload="beforeUpload"
                :file-list="restsFileImgList3"
                :headers="headers"
              >
                <div class="addImgBox">
                  <div class="addImgIcon">
                    <img src="@/assets/images/supplierImg/addImgIcon.png" alt />
                  </div>
                </div>
                <div class="imgIconTxt">
                  图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                  <span v-show="restsFileList3.length != 0"
                    >（{{ restsFileList3.length }}/2）</span
                  >。
                </div>
              </el-upload>
              <div class="UploadImgList" v-if="restsFileList3.length != 0">
                <div
                  class="UploadImgItem"
                  v-for="(restsFileItem, restsFileIndex) in restsFileList3"
                  :key="'restsFileItem' + restsFileIndex"
                >
                  <div class="UploadImgLeft">
                    <div class="UploadItemImg">
                      <img :src="restsFileItem.url" alt />
                    </div>
                    <div class="UploadItemInfo">
                      <div class="UploadItemName">
                        图片{{ restsFileIndex + 1 }}
                      </div>
                    </div>
                  </div>
                  <div class="UploadImgBtnList">
                    <div @click="handleRestsRemove3(restsFileItem)">删除</div>
                    <div
                      class="previewBtn"
                      @click="handlePictureCardPreview(restsFileItem)"
                    >
                      预览
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="btnList">
          <el-button class="backBtn" type="primary" @click="goBack()">取消</el-button>
          <el-button class="nextBtn" type="primary" @click="submitBtn()">提交</el-button>
          </div>-->
        </div>
      </el-form>
      <div class="bottomBtn">
        <el-button type="primary" @click="submitBtn('ruleForm')"
          >提 交</el-button
        >
        <el-button type="info" @click="goBack">取 消</el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      class="imgMaskDialog"
      title="预览图片"
    >
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
// import esoterica from './esoterica';  //快速通过审核秘籍
// import { getUploadUrl } from "../../../services/commonService";
// import {
//   checkShopNameServer,
//   saveDetailService,
// } from "../../../services/merchantsIn";saveSupplierAInfo
import {
  getSupplierADetailService, //查询一条甲方供应商
  updateSupplierAInfo, //更新一条甲方供应商
  uploadSupplierFilesService, //上传文件接口
  saveSupplierAInfo, //保存供应商接口
  getSupplierTypeList, //获取供应商一级类别列表接口
  getSuppliersubTypeList, //查询子类别列表接口
} from "../../../services/supplierMagServices";
import {
  getTempUrlService, //下载附件
} from "@/services/allContractServices";
import config from "@/common/config";
export default {
  name: "AddSupplierA",
  data() {
    return {
      editFlag: false,
      RouteParam: {}, //存储路由跳转参数
      supplierId: 0, //总包合同ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      uploadLimit: 1, //拖拽上传最多一张图片
      addImgUploadLimit: 2, //添加上传最多三十张图片
      addImgUploadLimit2: 2, //添加上传最多5张图片
      isShowFileList: false, //是否显示上传成功的列表
      firstSupplierTypeList: [], //一级供应商分类列表
      secondSupplierTypeList: [], //一级供应商分类列表
      thirdSupplierTypeList: [], //一级供应商分类列表
      uploadData: {
        //上传图片的参数
        // source: "merchantPC",
        // business: "shopPic"
      },
      uploadPicUrl: config.baseUrl + "/appuser-web/oss/upload/supplier/pic", //上传图片地址
      triangleFileList: [], //营业执照1上传图片成功的数据---三证合一
      triangleFileList1: [], //营业执照2上传图片成功的数据---三证合一
      identitycardFrontFileList: [], //身份证正面
      identitycardReverseFileList: [], //身份证反面
      taxpayerFileList: [], //纳税人资格证
      brandFileList: [], //商标图片数组
      brandFileImgList: [],
      qualityFileList: [], //质检图片数组
      qualityFileImgList: [],
      restsFileList1: [], //材料1图片数组
      restsFileImgList1: [], //材料1
      restsFileList2: [], //材料2图片数组
      restsFileImgList2: [], //材料2
      restsFileList3: [], //材料2图片数组
      restsFileImgList3: [], //材料2

      signinAddress: {
        //注册地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      },
      businessAddress: {
        //办公地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      },
      openingBankAddress: {
        //开户行地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      },

      enterpriseIcon: {
        selectIcon: require("@/assets/images/supplierImg/select.png"),
        selectActiveIcon: require("@/assets/images/supplierImg/selectActive.png"),
      },
      ruleForm: {
        companyName: "", //公司名称
        contactEmail: "", //联系人邮箱
        contactFax: "", //联系人传真
        contactName: "", //联系人姓名
        contactPhone: "", //联系人电话
        // idCardBackUrl: "", //身份证背面图片地址
        // idCardFrontUrl: "", //身份证正面图片地址
        idCardAttachmentList: [], //身份证地址列表
        legalPerson: "", //法人
        // licenseForOperationUrl: "", //经营许可证图片地址
        licenseAttachmentList: [],
        other1AttachmentList: [], //材料1图片地址
        other2AttachmentList: [], //材料2图片地址
        other3AttachmentList: [], //材料3图片地址
        publicBank: "", //对外开户行
        publicBankAccount: "", //对外账号
        publicBankAddress: "", //对外开户行地址
        publicBankNumber: "", //对外开户行行号
        publicCompanyName: "", //对外公司名称
        publicTaxAccount: "", //对外税号
        registeAddress: "", //注册地址
        workAddress: "", //办公地址
        workPhone: "", //办公电话
        publicPhone: "", //对外对公户电话
        // billAddress: "", //开票单位地址
        // billBank: "", //开票开户银行
        // billBankNumber: "", //开票开户行号
        // billHead: "", //开票抬头
        // billTaxNumber: "", //开票纳税人识别号
        topId: "", //一级分类
        typeRelList: [
          {
            secondId: "",
            thirdId: "",
            topId: 1,
          },
        ],
      },
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9（）]+$/,
            message: "请输入正确的公司名称",
            trigger: "change",
          },
        ],
        publicCompanyName: [
          { required: true, message: "请输入对外公司名称", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9（）]+$/,
            message: "请输入正确的公司名称",
          },
          // {pattern:/^(?!.*\（\（)(?!.*\）\）)(?!.*\-\-)(?!.*\+\+)(?!.*\·\·)[\u4E00-\u9FA5A-Za-z0-9\（\）\-\+\·]{1,99}$/,message:'店铺名称只允许使用中文、英文、数字（）-+·'}
        ],
        publicBankAddress: [
          { required: true, message: "请输入开户行地址", trigger: "blur" },
        ],
        publicBank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        publicBankAccount: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
        publicBankNumber: [
          { required: true, message: "请输入开户行行号", trigger: "blur" },
        ],
        publicPhone: [
          { required: true, message: "请输入对公户电话", trigger: "blur" },
          {
            pattern: /^([0-9-]+)$/,
            message: "请输入正确的对公户电话",
            trigger: "change",
          },
        ],
        registeAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        workAddress: [
          { required: true, message: "请输入办公地址", trigger: "blur" },
        ],
        publicTaxAccount: [
          { required: true, message: "请输入税号", trigger: "blur" },
          // {
          //   message: "只能输入数字",
          //   type: "number",
          //   trigger: "change",
          //   transform: (value) => Number(value),
          // },
        ],
        legalPerson: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
          {
            min: 2,
            max: 60,
            message: "姓名长度在 2 到 60 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "请输入正确的法人姓名",
            trigger: "change",
          },
        ],
        workPhone: [
          { required: true, message: "请输入办公电话", trigger: "blur" },
          {
            pattern: /^([0-9-]+)$/,
            message: "请输入正确的办公电话",
            trigger: "change",
          },
          // {
          //     message: "请输入正确的办公电话",
          //     type: "number",
          //     transform: value => Number(value),
          // },
        ],
        contactName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
          {
            min: 2,
            max: 12,
            message: "姓名长度在 2 到 12 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "请输入正确的联系人姓名",
            trigger: "change",
          },
        ],
        contactPhone: [
          { required: true, message: "请输入联系人手机", trigger: "blur" },
          {
            pattern:
              /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/,
            message: "请输入正确的联系人手机",
            trigger: "change",
          },
        ],
        contactEmail: [
          { required: true, message: "请输入联系人邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的联系人邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      isShopNameBool: false,
    };
  },
  components: {},
  props: {
    shopInfoData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    shopInfoData(val) {
      if (val != null) {
        this.init();
      }
    },
  },
  computed: {
    headers() {
      return {
        Authorization: sessionStorage.getItem("accessToken"),
      };
    },
  },
  mounted() {
    this.uploadPicUrl = config.baseUrl + "/appuser-web/oss/upload/supplier/pic"; //getUploadUrl();
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.editFlag = this.tabRouteParam ? this.tabRouteParam.editFlag : false;
      this.RouteParam = this.tabRouteParam;
      this.getSupplierTypeList(); //获取一级分类下拉列表
      if (this.editFlag) {
        //编辑 获取一条供应商信息
        this.supplierId = this.tabRouteParam.id;
        this.getSupplierDetail(this.supplierId);
      } else {
        this.ruleForm.topType = this.tabRouteParam
          ? this.tabRouteParam.topType
          : "aType";
        this.ruleForm.typeRelList[0].topId = 1;
        this.getsubSupplierTypeList(this.ruleForm.typeRelList[0].topId, 2); //一级分类为业主单位 获取二级分类
      }
    },
    //获取一条信息
    getSupplierDetail(supplierId) {
      if (this.RouteParam) {
        let param = {};
        param.supplierId = supplierId;
        getSupplierADetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.ruleForm = res.data;
              this.init();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //删除图片
    // closeBtnClick(closeIndex) {
    //   if (closeIndex == 1) {
    //     this.triangleFileList = [];
    //     this.ruleForm.licenseAttachmentList.splice(0, 1);
    //   } else if (closeIndex == 2) {
    //     this.identitycardFrontFileList = [];
    //     this.ruleForm.idCardAttachmentList.splice(0, 1);
    //   } else if (closeIndex == 3) {
    //     this.identitycardReverseFileList = [];
    //     this.ruleForm.idCardAttachmentList.splice(1, 1);
    //   } else if (closeIndex == 4) {
    //     this.triangleFileList1 = [];
    //     this.ruleForm.licenseAttachmentList.splice(1, 1);
    //   } else if (closeIndex == 5) {
    //     this.openAccountFileList = [];
    //   }
    // },
    //预览图片
    previewBtnClick(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    publicTaxAccountInput(value) {
      this.ruleForm.publicTaxAccount = value.replace(/[^A-Za-z0-9]/g, "");
    },
    // publicbillTaxNumberInput(value) {
    //   this.ruleForm.billTaxNumber = value.replace(/[^A-Za-z0-9]/g, "");
    // },
    setIsShowHelpExplain(index) {
      this.$emit("setIsShowHelpExplain", index);
    },
    shopNameBlur() {
      if (!this.ruleForm.shopName) {
        return;
      }
      let params = {
        shopName: this.ruleForm.shopName,
        shopCode: sessionStorage.getItem("shopCode"),
      };
      // checkShopNameServer(params).then(res => {
      //   if (res.resultCode == 0) {
      //     this.isShopNameBool = res.data;
      //     if (res.data) {
      //       this.$message.error("店铺名称重复");
      //     }
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    emptyHistoryData() {
      this.$refs["ruleForm"].resetFields();
      this.isShopNameBool = false;
      this.triangleFileList = []; //上传图片成功的数据---三证合一
      this.identitycardFrontFileList = []; //身份证正面
      this.identitycardReverseFileList = []; //身份证反面
      this.taxpayerFileList = []; //纳税人资格证
      this.brandFileList = []; //商标图片数组
      this.brandFileImgList = [];
      this.qualityFileList = []; //质检图片数组
      this.qualityFileImgList = [];
      this.restsFileList2 = []; //其他资质数组
      this.restsFileImgList2 = [];
      this.signinAddress = {
        //注册地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
      this.businessAddress = {
        //办公地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
      this.openingBankAddress = {
        //开户行地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
    },
    //初始化数据
    init() {
      if (
        null == this.ruleForm.typeRelList ||
        this.ruleForm.typeRelList.length == 0
      ) {
        this.ruleForm.typeRelList = [];
        this.ruleForm.typeRelList.push({
          secondId: "",
          thirdId: "",
          topId: 1,
        });
      }
      if (this.ruleForm.typeRelList[0].topId) {
        this.getsubSupplierTypeList(this.ruleForm.typeRelList[0].topId, 2);
        if (
          null != this.ruleForm.typeRelList[0].secondId &&
          this.ruleForm.typeRelList[0].secondId
        ) {
          this.getsubSupplierTypeList(this.ruleForm.typeRelList[0].secondId, 3);
        }
      }
      //  idCardAttachmentList: [], //身份证地址列表
      //   licenseAttachmentList: [],
      //   other1AttachmentList: [], //资质证明图片地址
      //   other2AttachmentList: [], //其他材料图片地址
      this.restsFileList1 = []; //材料1图片地址
      this.restsFileList2 = []; //材料2图片地址
      this.restsFileList3 = []; //材料3图片地址
      this.restsFileImgList1 = []; //其他材料1图片数组
      this.restsFileImgList2 = []; //其他材料2图片数组
      this.restsFileImgList3 = []; //其他材料2图片数组

      this.isShopNameBool = false;

      if (this.ruleForm.other1AttachmentList) {
        let len = this.ruleForm.other1AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList1.push({
            url: this.ruleForm.other1AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList1.push({
            url: this.ruleForm.other1AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other1AttachmentList = [];
      }
      if (this.ruleForm.other2AttachmentList) {
        let len = this.ruleForm.other2AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList2.push({
            url: this.ruleForm.other2AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList2.push({
            url: this.ruleForm.other2AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other2AttachmentList = [];
      }
      if (this.ruleForm.other3AttachmentList) {
        let len = this.ruleForm.other3AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList3.push({
            url: this.ruleForm.other3AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList3.push({
            url: this.ruleForm.other3AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other3AttachmentList = [];
      }
    },

    setRuleFormLongTime() {
      this.ruleForm.longTime = !this.ruleForm.longTime;
      if (this.ruleForm.longTime) {
        this.ruleForm.validityTime = [];
      }
    },
    fileChanged(file, fileList) {
      console.log(file);
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    },
    triangleUploadSuccess(res, file, fileList) {
      if (res.code == 10000000) {
        let reqParam = {
          filePath: res.data.path,
        };
        // this.ruleForm.licenseAttachmentList.push(res.data.path) ;
        // this.ruleForm.licenseAttachmentList[0]=res.data.path ;
        this.ruleForm.licenseAttachmentList[0] = {};
        this.ruleForm.licenseAttachmentList[0].attachmentItem = res.data.path;
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              // this.ruleForm.licenseForOperationUrl = res.data;
              // this.triangleFileList = [];
              this.triangleFileList = [];
              this.triangleFileList.push({ url: res.data });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        this.$alert("营业执照上传失败");
      }
    },
    triangleUploadSuccess1(res, file, fileList) {
      if (res.code == 10000000) {
        let reqParam = {
          filePath: res.data.path,
        };
        this.ruleForm.licenseAttachmentList[1] = {};
        this.ruleForm.licenseAttachmentList[1].attachmentItem = res.data.path;
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              // this.ruleForm.licenseForOperationUrl = res.data;
              this.triangleFileList1 = [];
              this.triangleFileList1.push({ url: res.data });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        this.$alert("营业执照上传失败");
      }
    },
    identitycardFrontUploadSuccess(res) {
      if (res.code == 10000000) {
        // this.ruleForm.idCardFrontUrl = res.data.path;
        this.ruleForm.idCardAttachmentList[0] = {};
        this.ruleForm.idCardAttachmentList[0].attachmentItem = res.data.path;
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              // this.ruleForm.idCardFrontUrl = res.data;
              this.identitycardFrontFileList = [];
              this.identitycardFrontFileList.push({ url: res.data });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("身份证正面照片上传失败");
      }
    },
    identitycardReverseUploadSuccess(res) {
      if (res.code == 10000000) {
        this.ruleForm.idCardAttachmentList[1] = {};
        this.ruleForm.idCardAttachmentList[1].attachmentItem = res.data.path;
        // this.ruleForm.idCardBackUrl = res.data.path;
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.identitycardReverseFileList = [];
              this.identitycardReverseFileList.push({ url: res.data });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("身份证反面照片上传失败");
      }
    },
    exceedFilesNum() {
      this.$alert("最多上传10张图片"),
        "错误",
        {
          confirmButtonText: "确定",
        };
    },
    exceedFilesNum2() {
      this.$alert("最多上传2张图片"),
        "错误",
        {
          confirmButtonText: "确定",
        };
    },
    restsUploadSuccess1(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.other1AttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.restsFileList1.push({ url: res.data });
              this.restsFileImgList1 = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },
    restsUploadSuccess2(res, file, list) {
      if (res.code == 10000000) {
        // this.ruleForm.idCardBackUrl = res.data.path;
        this.ruleForm.other2AttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.restsFileList2.push({ url: res.data });
              this.restsFileImgList2 = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("其他材料照片上传失败");
      }
    },
    restsUploadSuccess3(res, file, list) {
      if (res.code == 10000000) {
        // this.ruleForm.idCardBackUrl = res.data.path;
        this.ruleForm.other3AttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.restsFileList3.push({ url: res.data });
              this.restsFileImgList3 = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("其他材料照片上传失败");
      }
    },
    handleRestsRemove1(cosmeticSanitationFileItem) {
      let index = this.restsFileList1.indexOf(cosmeticSanitationFileItem);
      this.restsFileList1.splice(index, 1);
      this.ruleForm.other1AttachmentList.splice(index, 1);
      this.restsFileImgList1.splice(index, 1);
    },
    handleRestsRemove2(restsFileItem) {
      let index = this.restsFileList2.indexOf(restsFileItem);
      this.ruleForm.other2AttachmentList.splice(index, 1);
      this.restsFileList2.splice(index, 1);
      this.restsFileImgList2.splice(index, 1);
    },
    handleRestsRemove3(restsFileItem) {
      let index = this.restsFileList3.indexOf(restsFileItem);
      this.ruleForm.other3AttachmentList.splice(index, 1);
      this.restsFileList3.splice(index, 1);
      this.restsFileImgList2.splice(index, 1);
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 图片大小不能超过1M
    beforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (testmsg == "jpeg" || testmsg == "jpg" || testmsg == "png") {
        if (!isLt2M) {
          this.$alert("图片大小不能超过1M", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          return true;
        }
      } else {
        this.$alert("仅支持jpg、jpeg和png格式的图片", {
          confirmButtonText: "确定",
        });
        return false;
      }
    },

    // 图片大小不能超过5M
    beforeMaxUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (
        testmsg == "jpeg" ||
        testmsg == "jpg" ||
        testmsg == "png" ||
        testmsg == "JPEG" ||
        testmsg == "JPG" ||
        testmsg == "PNG"
      ) {
        if (!isLt2M) {
          this.$alert("图片大小不能超过5M", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          return true;
        }
      } else {
        this.$alert("仅支持jpg、jpeg和png格式的图片", {
          confirmButtonText: "确定",
        });
        return false;
      }
    },

    dateFormat() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    },
    //提交
    submitBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (
          //   this.triangleFileList.length == 0 &&
          //   this.triangleFileList1.length == 0
          // ) {
          //   this.$message.error("请上传营业执照");
          //   return;
          // }

          // if (this.identitycardFrontFileList.length == 0) {
          //   this.$message.error("请上传法人身份证正面照片");
          //   return;
          // }
          // if (this.identitycardReverseFileList.length == 0) {
          //   this.$message.error("请上传法人身份证反面照片");
          //   return;
          // }
          if (this.editFlag) {
            //更新供应商
            this.ruleForm.id = this.supplierId;
            updateSupplierAInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                this.$refs.ruleForm.clearValidate();
                this.$refs["ruleForm"].clearValidate();
                this.bus.$emit("tabClose", "editSupplierAPage");
                this.bus.$emit("navMenuChange", {
                  routeId: "supplierAListPage",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveSupplierAInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                this.$refs.ruleForm.clearValidate();
                this.$refs["ruleForm"].clearValidate();
                this.bus.$emit("tabClose", "addSupplierAPage");
                this.bus.$emit("navMenuChange", {
                  routeId: "supplierAListPage",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消按钮
    goBack() {
      let that = this;
      this.$refs.ruleForm.clearValidate();
      // this.ruleForm.licenseAttachmentList = []; //营业执照
      // this.ruleForm.idCardAttachmentList = []; //身份证正面
      this.ruleForm.other1AttachmentList = []; //资质证明
      this.ruleForm.other2AttachmentList = []; //其他材料

      if (this.editFlag) {
        this.bus.$emit("tabClose", "editSupplierAPage");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierAListPage",
        });
      } else {
        this.bus.$emit("tabClose", "addSupplierAPage");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierAListPage",
        });
      }
    },
    //获取一级供应商分类列表
    getSupplierTypeList() {
      let reqParam = {
        pageIndex: "1",
        pageSize: "50",
      };
      getSupplierTypeList().then(
        (res) => {
          if (res.code == 10000000) {
            this.firstSupplierTypeList = res.data;
            // this.getSupplierDetail(this.supplierId);
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },
    //获取下级供应商分类列表
    getsubSupplierTypeList(val, typeLevel) {
      let param = {};
      if (val&&val!='') {
        param.supplierTypeId = val;
        getSuppliersubTypeList(param)
          .then((res) => {
            if (res.code == 10000000) {
              if (typeLevel == 2) {
                this.secondSupplierTypeList = res.data;
                if (
                  null != this.ruleForm.typeRelList[0].secondId &&
                  "" != this.ruleForm.typeRelList[0].secondId
                ) {
                  this.ruleForm.typeRelList[0].secondId =
                    this.ruleForm.typeRelList[0].secondId;
                }
              } else {
                this.thirdSupplierTypeList = res.data;
                if (
                  null != this.ruleForm.typeRelList[0].thirdId &&
                  "" != this.ruleForm.typeRelList[0].thirdId
                ) {
                  this.ruleForm.typeRelList[0].thirdId =
                    this.ruleForm.typeRelList[0].thirdId;
                }
              }
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch(() => {
            this.$message.error("系统异常");
          });
      }else{
        this.ruleForm.typeRelList[0].thirdId = "";
      }
    },
    //选择完一级分类获取二级分类
    firstSupplierTypeChange(val) {
      this.getsubSupplierTypeList(val, 2);
      this.secondSupplierTypeList = [];
      this.thirdSupplierTypeList = [];
      this.ruleForm.typeRelList[0].secondId = "";
      this.ruleForm.typeRelList[0].thirdId = "";
    },
    //选择完二级分类获取三级分类
    secondSupplierTypeChange(val) {
      // let obj = {};
      // obj = this.SupplierAList.find(item => {
      //   return item.id == val; //筛选出匹配数据
      // });
      // this.dialogForm.partyA = obj.companyName;
      this.getsubSupplierTypeList(val, 3);
    },
  },
};
</script>

<style scoped lang="scss">
.enterpriseAndCommonality {
  background-color: white;
  // height: 100%;
}
/deep/.el-popover {
  padding: 24px;
}
/deep/.imgMaskDialog {
  // .el-dialog {
  //   width: 30%;
  // }
  .el-dialog__close {
    font-size: 30px;
    font-weight: 600;
  }
}
.AddSupplierA {
  width: 72%;
}
@media only screen and(max-width:1680px) {
  .AddSupplierA {
    width: 90%;
  }
}
.AddSupplierA {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
  .bottomBtn {
    border-top: 1px solid #e6e6e6;
    width: 80%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin-bottom: 20px;
  }
  .AddSupplierATitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .AddSupplierAContent {
    padding: 24px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }

  .businessBox {
    display: flex;
    margin-bottom: 24px;
    .businessTitle {
      width: 140px;
      padding-right: 12px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-wrap: wrap;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }
      .startTxt {
        color: #f56c6c;
        margin-right: 4px;
      }
      img {
        width: 14px;
        height: 14px;
        margin: 4px 2px 0 4px;
      }
    }
    .certificateTitle {
      width: 140px;
      padding-right: 12px;
      box-sizing: border-box;
      text-align: right;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }
      img {
        width: 14px;
        height: 14px;
        margin: 4px 2px 0 4px;
      }
    }
    .secondUpload {
      margin-top: 0px;
    }
    /deep/.upload-demo {
      .el-upload-dragger {
        width: 380px;
        height: 194px;
        background: rgba(251, 251, 251, 1);
        border-radius: 2px;
        border: 1px dashed rgba(217, 217, 217, 1);
        .fileImgIcon {
          margin: 39px 0 21px 0;
        }
        .dragTxt {
          width: 242px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          margin: 0 auto;
        }
        .imgSizeTxt {
          width: 242px;
          height: 34px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin: 2px auto 0;
        }
      }
      .uploadImgBox {
        width: 100%;
        height: 194px;
        position: relative;
        img {
          width: 100%;
        }
        .coloseAndPreviewBtnList {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          position: absolute;
          top: 157px;
          div {
            width: 56px;
            height: 26px;
            background: rgba(0, 0, 0, 1);
            border-radius: 13px;
            opacity: 0.8;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 26px;
          }
          .closeBtn {
            margin-right: 8px;
          }
          .PreviewBtn {
            margin-right: 10px;
          }
        }
      }
    }
    /deep/.selectBox {
      .selectItem {
        width: 121px;
        height: 32px;
        margin-right: 8px;
        .el-input__inner {
          width: 121px;
          height: 32px;
        }
        .el-input__icon {
          line-height: 32px;
        }
      }
      .selectItem:nth-child(3n) {
        margin-right: 0px;
      }
      .textareaTxt {
        width: 380px;
        margin-top: 10px;
        textarea {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
  .addImgUploadBox {
    .addImgUpload {
      .addImgBox {
        width: 50px;
        height: 50px;
        border-radius: 2px;
        border: 1px dashed rgba(223, 223, 228, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        .addImgIcon {
          width: 18px;
          height: 18px;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
      .imgIconTxt {
        margin-top: 7px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .UploadImgList {
      margin-top: 16px;
      .UploadImgItem {
        width: 380px;
        height: 66px;
        background: rgba(251, 251, 251, 1);
        border-radius: 4px;
        border: 1px dashed rgba(217, 217, 217, 1);
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        .UploadImgLeft {
          height: 66px;
          display: flex;
          align-items: center;
          .UploadItemImg {
            width: 54px;
            height: 54px;
            padding-left: 8px;
            overflow: hidden;
            img {
              width: 54px;
            }
          }
          .UploadItemInfo {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 13px;
            .UploadItemName {
              width: 200px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .UploadItemSize {
              height: 17px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 17px;
              text-align: left;
              margin-top: 6px;
            }
          }
        }
        .UploadImgBtnList {
          display: flex;
          align-items: flex-end;
          div {
            width: 28px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            margin-bottom: 11px;
            cursor: pointer;
          }
          .previewBtn {
            margin-left: 12px;
            margin-right: 13px;
          }
        }
      }
      .UploadImgItem:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
